export { CORE_ICONS_MAPPING } from './core'
export { LAZY_ICONS_MAPPING } from './lazy'
